import { render, staticRenderFns } from "./clientProfileContact.vue?vue&type=template&id=4318aacf&scoped=true"
import script from "./clientProfileContact.vue?vue&type=script&lang=js"
export * from "./clientProfileContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4318aacf",
  null
  
)

export default component.exports